import { FiltroEmbarqueCompleto } from "../../models/FiltroEmbarqueCompleto.ts";
import { RelatorioEligibilidadeBrfResponse } from "../../models/RelatorioEligibilidadeBrfResponse.ts";
import { api } from "../ModuloGerenciador/UrlPadrao";

interface BuscarRelatorioEligibilidadeDto {
	token: string;
	filtro: FiltroEmbarqueCompleto;
}

export const buscarRelatorioEligibilidade = async ({
	token,
	filtro,
}: BuscarRelatorioEligibilidadeDto): Promise<RelatorioEligibilidadeBrfResponse> => {
	const params = new URLSearchParams();
	Object.entries(filtro).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			value.forEach((item) => params.append(key, item.toString()));
		} else if (value !== undefined && value !== null) {
			params.append(key, value.toString());
		}
	});
    
	const response = await api.get("RelatorioElegibilidade", {
		params,
		headers: {
			Authorization: token,
		},
	});

	return response.data;
};
